import React, { useState } from "react";
import { Link } from "react-router-dom";
import Icons from "../../myIcon/Icons";
import { Modal } from "react-bootstrap";

const highlights = [
  {
    title: "Featured on Bigg Boss 17",
    description:
      "Sonam Label was featured in Bigg Boss 17, in a segment with Sana Raees Khan, celebrating the brand's craftsmanship on national television.",
    image: "/image/videothumb-1.webp",
    video: "../video/bigg-boss.mp4",
  },
  {
    title: "Designer of the Year",
    description:
      "Sonam Brahme was awarded Best Bridal and Groom Wear — Designer of the Year, recognising her contribution to bridal couture.",
    image: "/image/videothumb-4.webp",
    video: "../video/award.mp4",
  },
];

const testimonials = [
  { image: "/image/videothumb-3.webp", video: "../video/words-trust.mp4" },
  { image: "/image/videothumb-2.webp", video: "../video/crafted-with-trust.mp4" },
];

export default function Recognition() {
  const [modalShow, setModalShow] = useState(false);
  const [activeVideo, setActiveVideo] = useState("");

  const openVideo = (video) => {
    setActiveVideo(video);
    setModalShow(true);
  };

  return (
    <>
      <section className="recognition-section">
        <div className="container">
          <div className="recognition-head">
            <h2 className="heading">Recognised, Trusted, Loved</h2>
          </div>

          <div className="row">
            {highlights.map((item, index) => (
              <div className="col-lg-6 col-md-6" key={index}>
                <div className="recognition-box" onClick={() => openVideo(item.video)}>
                  <img src={item.image} className="img-responsive" alt={item.title} loading="lazy" />
                  <span className="video-play-button">
                    <span></span>
                  </span>
                </div>
                <div className="recognition-content">
                  <h4 className="heading">{item.title}</h4>
                  <p>{item.description}</p>
                </div>
              </div>
            ))}
          </div>

          <div className="recognition-testimonial row align-items-center">
            <div className="col-lg-6 col-md-6">
              <h3 className="heading">In Their Own Words</h3>
              <p>
                Hear it from the brides and families who trusted us with their story. Watch their testimonials on
                the studio&rsquo;s journey, from first fitting to final reveal.
              </p>
            </div>

            {testimonials.map((item, index) => (
              <div className="col-lg-3 col-md-3 col-6" key={index}>
                <div className="recognition-thumb" onClick={() => openVideo(item.video)}>
                  <img src={item.image} className="img-responsive" alt="Testimonial" loading="lazy" />
                  <span className="video-play-button">
                    <span></span>
                  </span>
                </div>
              </div>
            ))}

            <div className="col-lg-12">
              <div className="recognition-testimonial-btn">
                <Link to="/contact-us#contact-form" className="default-btn red-default">
                  Book My Consultation
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Modal
        className="homevideo-popup"
        show={modalShow}
        onHide={() => setModalShow(false)}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
      >
        <Modal.Body>
          <button className="popup-close" onClick={() => setModalShow(false)}>
            <Icons name="cross" />
          </button>
          <iframe
            className="video-player"
            src={`${activeVideo}?autoplay=1`}
            allow="autoplay; encrypted-media"
            allowFullScreen
            title="Video"
            frameBorder="0"
          />
        </Modal.Body>
      </Modal>
    </>
  );
}
